// src/hooks/useFirstRunLoginPrefetch.js
import { useEffect } from "react";

export default function useFirstRunLoginPrefetch({
  uid,
  db,
  ensureFirstRun,
  variants,
  ttlMs = 10 * 60 * 1000,
  requireCompleted = false,
}) {
  useEffect(() => {
    if (!uid) return;
    if (!db) return;
    if (!Array.isArray(variants) || variants.length === 0) return;

    const t = window.setTimeout(() => {
      ensureFirstRun({ db, uid, variants, ttlMs, requireCompleted }).catch(
        () => {},
      );
    }, 0);

    return () => window.clearTimeout(t);
  }, [uid, db, ensureFirstRun, variants, ttlMs, requireCompleted]);
}
